import styled from 'styled-components';

import OriginFlag from '~/src/common/components/OriginFlag';
import { COLORS } from '~/src/common/theme';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Tags = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const CustomTag = styled.div`
  display: inline-flex;
  align-items: center;
  white-space: pre;
  padding: 0 8px;
  border-radius: 4px;
  background-color: ${COLORS.FLAG_DARKLABEL};
  color: ${COLORS.NEUTRAL_WHITE};
  font-weight: 700;
  font-size: 12px;
  line-height: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
export const Label = styled.span`
  color: ${COLORS.NEUTRAL_DEFAULT};
  font-size: 12px;
  line-height: 16px;

  ::first-letter {
    text-transform: uppercase;
  }
`;

export const Flag = styled(OriginFlag)`
  height: 40px;
  border-radius: 4px;
`;

export const ProductLabels = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  overflow-x: scroll;
  scrollbar-width: none;

  & > * {
    flex-shrink: 0;
  }
`;

export const ProductLabel = styled.img`
  width: 40px;
  height: 40px;
`;
